
import { ConsentStatus, CONSENT_STATUS_ENUM } from '@/common/gaHelper';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const analyticsConsentModule = namespace('analyticsConsent');

@Component
export default class ManageConsentGAModal extends Vue {
  @Prop({ default: true }) show!: boolean;

  @analyticsConsentModule.State('consentStatus') consentStatus!: ConsentStatus;
  @analyticsConsentModule.Mutation('setConsentStatus') setConsentStatus!: (consent: ConsentStatus) => void;

  readonly CONSENT_STATUS_ENUM = CONSENT_STATUS_ENUM;

  closeModal () {
    this.$emit('close');
  }

  saveConsent () {
    if (this.consentStatus === this.CONSENT_STATUS_ENUM.ACCEPTED) {
      this.$gtag.optIn();
    } else {
      this.$gtag.optOut();
    }
    this.closeModal();
  }
}
